import { lazy } from "react";
import Loadable from "components/Loadable";

// Lazy-loaded components
const HeaderField = Loadable(lazy(() => import("../HeaderField")));
const Theme = Loadable(lazy(() => import("../Theme")));
const AssignedStandardList = Loadable(
  lazy(() => import("pages/standards/AssignedStandardList"))
);
const Organogram = Loadable(lazy(() => import("../Organogram/Organogram")));
const InteractionOfProcess = Loadable(
  lazy(() => import("../InteractionOfProcess"))
);
const ListOfProcedure = Loadable(lazy(() => import("../ListOfProcedure")));
const RolesAndResponsibility = Loadable(
  lazy(() => import("../RolesAndResponsibility"))
);
const NewAddEditManual = Loadable(lazy(() => import("../NewAddEditManual")));
const YearList = Loadable(lazy(() => import("../../molecules/YearList")));
const List = Loadable(lazy(() => import("../../molecules/List")));
const Folder = Loadable(lazy(() => import("../../molecules/Folder")));
const Detail = Loadable(lazy(() => import("../../molecules/Detail")));
const NewDocStyle = Loadable(lazy(() => import("../DocStyle/DocStyle")));

const qualityManualRoutes = [
  {
    path: "standards",
    children: [
      { path: "header-field", element: <HeaderField /> },
      { path: "doc-style", element: <NewDocStyle /> },
      { path: "themes", element: <Theme /> },
      { path: "standard-list", element: <AssignedStandardList /> },
      { path: "add-edit-manual", element: <NewAddEditManual /> },
      { path: "organogram", element: <Organogram /> },
      { path: "interaction-of-process", element: <InteractionOfProcess /> },
      { path: "list-of-procedure", element: <ListOfProcedure /> },
      { path: "roles-and-responsibility", element: <RolesAndResponsibility /> },
      {
        path: "quality-manual",
        element: (
          <List
            moduleType="qualityManual"
            limit={10}
            name="Quality Manual"
            navigateUrl="quality-manual"
          />
        )
      },
      {
        path: "quality-manual-detail-year/:documentId/:type?",
        element: (
          <YearList
            moduleType="qualityManual"
            name="Quality Manual"
            navigateUrl="quality-manual-detail"
          />
        )
      },
      {
        path: "quality-manual/:documentId",
        element: (
          <Folder
            moduleType="qualityManual"
            name="Quality Manual"
            detailUrl="quality-manual-detail"
            yearUrl="quality-manual-detail-year"
          />
        )
      },
      {
        path: "quality-manual-detail/:documentId/:type?/:year?",
        element: (
          <Detail moduleType="qualityManual" name="Quality Manual" />
        )
      }
    ]
  }
];

export default qualityManualRoutes;
